"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _constants = require("./constants");

var style =
/*#__PURE__*/
(0, _core.css)("text-align:center;padding:18px 0 14px;background:", _constants.CLOCK_WRAPPER_BACKGROUND, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3N0eWxlcy9jbG9jay13cmFwcGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdpQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9zdHlsZXMvY2xvY2std3JhcHBlci50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IENMT0NLX1dSQVBQRVJfQkFDS0dST1VORCB9IGZyb20gJy4vY29uc3RhbnRzJ1xuXG5jb25zdCBzdHlsZSA9IGNzc2Bcblx0dGV4dC1hbGlnbjogY2VudGVyO1xuXHRwYWRkaW5nOiAxOHB4IDAgMTRweDtcblx0YmFja2dyb3VuZDogJHtDTE9DS19XUkFQUEVSX0JBQ0tHUk9VTkR9O1xuYFxuXG5leHBvcnQgZGVmYXVsdCBzdHlsZVxuIl19 */"));
var _default = style;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-timekeeper/lib/components/styles/clock-wrapper.js
// module id = 6308
// module chunks = 39